//Scroll for the right layout
//Scroll is used between adv components and pages when adv component.layout === 'right'
//And when course has course.use_right_nav: true

//styles are stored in main.scss right now for AngularJS components

import { RWSService } from '@rws-framework/client';

class SnapScrollService extends RWSService {
  static _IN_CLIENT: boolean = true;

  gotoPrevious(elementClass: string = '', timeout: number = 100) {
    if (!elementClass) return;
    const component = document.querySelector(`.${elementClass}`);
    if (!component) return;
    component.classList.add('slide-in-reverse')
    component.classList.add('out')
    component.classList.remove('slide-out')

    setTimeout(() => {
      const component2 = document.querySelector(`.${elementClass}`);
      if (!component2) return;
      component2.classList.add('slide-out-reverse')
      component2.classList.remove('out')
    }, timeout);
  };

  gotoNext(elementClass: string = '', timeout: number = 100) {
    if (!elementClass)  return;
    const component = document.querySelector(`.${elementClass}`);
    if (!component) return;
    component.classList.add('slide-out')
    component.classList.add('out');
    component.classList.remove('slide-out-reverse');

    setTimeout(() => {
      const component2 = document.querySelector(`.${elementClass}`);
      if (!component2) return;
      component2.classList.add('slide-in');
      component2.classList.remove('out');
    }, timeout);
  }
}

export default SnapScrollService.getSingleton();

export {SnapScrollService as SnapScrollServiceInstance}
